import { FC } from "react";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { cx } from "@jugl-web/utils";
import { Portal } from "@headlessui/react";
import loaderAnimationData from "./assets/loader.json";

type PageLoaderFullVariant = "fullscreen" | "content";

export const PageLoaderFull: FC<{
  isActive?: boolean;
  isTransparent?: boolean;
  className?: string;
  variant?: PageLoaderFullVariant;
}> = ({
  isActive = true,
  isTransparent,
  className,
  variant = "fullscreen",
}) => {
  if (!isActive) {
    return null;
  }

  const isContentVariant = variant === "content";

  const content = (
    <div
      className={cx(
        "flex items-center justify-center",
        isContentVariant
          ? "relative z-[-1] h-full w-full"
          : "fixed inset-0 z-[10000]",
        className
      )}
      style={{
        background: isTransparent ? "rgba(16, 17, 42, 0.38)" : "#fff",
        backdropFilter: isTransparent ? "blur(1.5px)" : undefined,
      }}
    >
      <Lottie
        options={{ animationData: loaderAnimationData }}
        height={68}
        width={68}
      />
    </div>
  );

  if (isContentVariant) {
    return content;
  }

  return <Portal>{content}</Portal>;
};
